module.exports = __webpack_public_path__ + "static/img/cont58_06.9a9a27d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont58_06.jpg
// module id = 2/8O
// module chunks = 0